var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(!_vm.hidden && _vm.wrapper)?_c('div',{staticClass:"number-user-online mt-4 mb-2 fs-md text-gray"},[_vm._v(" "+_vm._s(_vm.displayMessage)+" ")]):(!_vm.hidden)?_c('span',[_vm._v(" "+_vm._s(_vm.displayMessage)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }